import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';

import { IContactData } from '@modules/ContactManager/components/Tabs/components/Deals/interfaces';
import { queryParams } from '@shared/commonFunctions';
import { SERVICES } from '@shared/constants/apiConfig';
import { Loader } from '@shared/enhancers/withLoader';
import { useTabs } from '@shared/hooks/useTabs';
import { StyleOverride } from '@styles/DealSheet/DealSheetStyles';

import { DealSheetPanels } from './components/DealSheetPanels';
import { IDealSheet } from './interfaces';

export const DealSheet = () => {
  const params = queryParams();
  const location = useLocation();
  const { openTab } = useTabs();

  const { data: contact } = useSWR<IContactData>(`/${SERVICES.CONTACT}/contacts/${params.id}`);
  const { data = [], mutate, isLoading } = useSWR<IDealSheet[]>(
    `/${SERVICES.ACCOUNTING}/accounting/dealsheet/${params.dealId}`,
    {
      revalidateOnMount: true,
      fallbackData: []
    });

  const [dealSheets, setDealSheets] = useState<IDealSheet[]>();

  useEffect(() => {
    if (data && !isLoading) {
      const dealSheetData = [...data].sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
      setDealSheets(dealSheetData);
    }
  }, [data, isLoading]);

  useEffect(() => {
    if (contact) {
      const title = `${contact.firstName} ${contact.lastName} - Deal Sheet`;

      openTab({
        route: `${location.pathname.toString()}${location.search}`,
        title,
      });
    }
  }, [location.pathname, location.search, contact]);

  return (
    <>
      <StyleOverride />

      {isLoading ? (
        <Loader />
      ) : (
        <DealSheetPanels
          refresh={mutate}
          dealSheets={dealSheets}
          customerName={`${contact?.firstName || ''} ${contact?.lastName || ''}`}
          dealId={params?.dealId ?? ''}
        />
      )}
    </>
  );
};
